export default class ProductRecommendations {
  constructor({ el, isLargeQuery }) {
    this.el = el;
    this.isLargeQuery = isLargeQuery;

    this.init();
  }

  init() {
    const url = this.el.dataset.url;

    if (!url) {
      return;
    }

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.related-products');

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.el.innerHTML = recommendations.innerHTML;
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }
}
